module.exports = __webpack_public_path__ + "media/images/lb/833-5788f61e5ee7abf6263dca89b799c66b.svg";